import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import { getCookie, isMobileScreen, sanitizeLinks } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { commonFeedActions } from '../../actions'
import ReadMore from 'srcReact/components/common2/ReadMore'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import {
  getParsedMessage,
  isMessageGiftLink,
  isMessageWithAllLinks,
  trimDivsFromMessage
} from 'srcReact/helpers/feedHelper'
import Tag from 'srcReact/components/common2/Tag'

function MessageBody({ feed, entity, isComment, isModal, isNative, renderDescription, renderLinkPreview, level }) {
  const dispatch = useDispatch()
  const [feedMessage, setFeedMessage] = useState('')
  const [entityId, setEntityId] = useState(0)
  const { t } = useTranslation()
  const [showTranslation, setShowTranslation] = useState(false)
  const [selectedLanguage, setSelectedLanguage] = useState('')
  const [isGifLink, setIsGifLink] = useState(false)
  const [isOnlyLink, setIsOnlyLink] = useState(false)
  const [messageWithTrimmedLine, setMessageWithTrimmedLine] = useState('')

  useEffect(() => {
    if (feed) {
      const parseMessage = getParsedMessage(feed?.message)

      //trim empty lines from start and end of the message
      const trimmedMessage = trimDivsFromMessage(
        feed?.message,
        parseMessage,
        feed.newsfeed_template,
        feed.is_automatic_message
      )
      setMessageWithTrimmedLine(trimmedMessage)

      //check if message is a gif link
      const allLinksAreGifImages = isMessageGiftLink(parseMessage)
      if (allLinksAreGifImages) {
        setIsGifLink(true)
      }
      //check if message is a gif link
      const messageIsAllLinks = isMessageWithAllLinks(parseMessage)
      if (messageIsAllLinks) {
        setIsOnlyLink(true)
      }

      //set the target of link depending on message type
      const anchors = parseMessage.getElementsByTagName('a')
      Array.from(anchors).forEach((a) => {
        if (a.classList.contains('gcard__gotoText') || a.classList.contains('gcard__gotoIcon')) {
          a.setAttribute('target', '_self')
        } else {
          a.setAttribute('target', '_blank')
        }
      })
      setFeedMessage(parseMessage)
      ///set id for redirection
      const element = parseMessage.querySelector('[data-id]')
      if (element) {
        const id = element.getAttribute('data-id')
        if (id && parseInt(id) > 0) {
          setEntityId(id)
        }
      }
      const currentLanguage = getCookie('mixr-lang')
      if (feed.is_automatic_message === 0 && !isEmpty(feed.language) && currentLanguage !== feed.language) {
        setShowTranslation(true)
      } else {
      }
    }
  }, [feed])

  const redirectTo = (type) => {
    if (type === 'group') {
      redirectToPage(`/0/home/group/${entityId}`, isNative, true)
    } else if (type === 'mixr') {
      redirectToPage(`/0/home/event/${entityId}`, isNative, true)
    }
  }

  const translateMessage = (messageId, originalText) => {
    const orgId = getCurrentOrgId()
    const currentLanguage = getCookie('mixr-lang')
    dispatch(commonFeedActions.translateMessage(orgId, messageId, originalText, currentLanguage))
  }

  const handleTranslate = () => {
    if (feed.translatedText) {
      setSelectedLanguage(selectedLanguage === feed.languageSource ? feed.languageTarget : feed.languageSource)
    } else {
      translateMessage(feed.id, feedMessage.body.innerHTML)
    }
  }

  const renderTranslateButton = () => {
    return (
      <button className={`${styles.translate} ${isComment && styles.translateInComment}`} onClick={handleTranslate}>
        {t('global.translate')}
      </button>
    )
  }

  const renderOrginaltextButton = () => {
    return (
      <button className={`${styles.translate} ${isComment && styles.translateInComment}`} onClick={handleTranslate}>
        {t('global.originalText')}
      </button>
    )
  }
  return (
    <React.Fragment>
      {feed.newsfeed_template === 'standard' && (
        <div
          id={feed.id}
          data-typeid={entity && entity.id}
          data-type={entity && entity.type}
          data-groupid={entity && entity.groupId}
          role='button'
          className={`${styles.messageContent} ${
            level === 2 ? styles.messageContentInComment2 : level === 3 ? styles.messageContentInComment3 : ''
          } ${(isGifLink || isOnlyLink) && styles.hideMessageContent}`}>
          <ReadMore
            enableTrim={!isModal} //do not trim for modal
            maxLines={
              isMobileScreen() ? (level === 1 ? 6 : appConstantSettings.SHOW_MORE_MAX_LINES) : level === 1 ? 12 : 6
            }
            showMoreText={t('global.seeMore')}
            showLessText={t('global.seeLess')}>
            {selectedLanguage !== feed.languageSource && feed.translatedText
              ? feed.translatedText
              : sanitizeLinks(messageWithTrimmedLine) || feedMessage?.body?.innerHTML}
            {/* show feedMessage?.body?.innerHTML if feedMessage?.body?.innerHTML contains only text element and not div element */}
            {/* e.g. user created this group */}
          </ReadMore>
        </div>
      )}

      {showTranslation
        ? feed.translatedText
          ? feed.languageSource !== selectedLanguage
            ? renderOrginaltextButton()
            : renderTranslateButton()
          : renderTranslateButton()
        : null}

      {feed.newsfeed_template === 'mixr_creation' && (
        <React.Fragment>
          <div role='button' className={styles.messageContent}>
            {renderDescription()}
          </div>
          <div role='button' onClick={() => redirectTo('mixr')} className={styles.newMixrMessageContent}>
            <span dangerouslySetInnerHTML={{ __html: feedMessage && feedMessage.body.innerHTML }} />
            {feed.group_type === 'expertise' && (
              <Tag
                text={t('group.createGroup.groupType.expertise.titleMixr')}
                color='purple'
                position='top'
                className={styles.expertiseMixrTag}
              />
            )}
          </div>
        </React.Fragment>
      )}
      {feed.newsfeed_template === 'group_creation' && (
        <React.Fragment>
          <div className={styles.messageContent}>{renderDescription()}</div>
          <div role='button' className={styles.newGroupMessageContent} onClick={() => redirectTo('group')}>
            <span dangerouslySetInnerHTML={{ __html: feedMessage && feedMessage.body.innerHTML }} />
            <div className={`${styles.gotoGroup} ${feed.group_type === 'expertise' && styles.gotoGroupExpertise}`}>
              <span>{t('global.gotoGroup')}</span>
              <Icon size='large24' name='arrow-right' />
            </div>
            {feed.group_type === 'expertise' && (
              <React.Fragment>
                <Tag
                  text={t('group.createGroup.groupType.expertise.title')}
                  color='purple'
                  position='left'
                  className={styles.expertiseTag}
                />
                <div className={styles.expertiseGroup}>
                  <Icon styleModifier={styles.icon} name='star-solid' size='large24' />
                  <div className={`${styles.backgroundImage} ${styles.purple}`} />
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      )}
      {renderLinkPreview(isGifLink)}
    </React.Fragment>
  )
}

export default MessageBody
